<template>
  <div>
    <GalleryComponent
      v-if="showGallery"
      :images="imagesGallery"
      :index="galleryIndex"
      :open="showGallery"
      @close="defineGallery({show: false, images: [], index: 0})"
    />
    <div :class="{'nav-open': $sidebar.showSidebar}">
      <notifications transition-name="notification-list" transition-mode="out-in">

      </notifications>
      <transition
        name="fade"
        mode="out-in"
      >
        <router-view></router-view>
      </transition>
      <!-- Essa div serve somente para tocar no state e fazer com que ele fique carregado em toda a aplicação. -->
      <div v-show="false">
        {{ config }}
      </div>
    </div>
  </div>
</template>

<script>
  import GalleryComponent from 'src/components/GalleryComponent'
  // Loading some plugin css asynchronously
  import {mapGetters, mapActions} from 'vuex'

  import('sweetalert2/dist/sweetalert2.css')
  import('vue-notifyjs/themes/default.css')

  export default {
    components: {
      GalleryComponent
    },
    computed: {
      ...mapGetters('gallery', ['showGallery', 'imagesGallery', 'galleryIndex']),
      ...mapGetters(['config', 'user']),
      ...mapGetters('users', {users: 'users'}),
      ...mapGetters('project', ['project'])
    },

    methods: {
      ...mapActions('gallery', ['defineGallery']),
      ...mapActions('users', {fetchUsers: 'fetchAll', fetchViewAll: 'fetchViewAll', resetUsers: 'resetAll'}),
      ...mapActions('project', {fetchProject: 'fetchOne'})
    },

    mounted () {
      this.fetchProject('config')
        .then((project) => {
          localStorage.setItem('eventLabel', project.hasOwnProperty('eventLabel') ? project.eventLabel : 'evento')
        })
      if (this.users.length === 0 && this.user.hasOwnProperty('_id')) {
        this.fetchUsers({
          limit: 99999,
          sort: {field: 'createdAt', direction: 'desc'}
        })
      } else {
        this.resetUsers()
      }
    }
  }
</script>
<style lang="scss">
  .notifications.vue-notifyjs {
    .notification-list-move {
      transition: transform 0.3s, opacity 0.4s;
    }

    .notification-list-item {
      display: inline-block;
      margin-right: 10px;

    }

    .notification-list-enter-active, .notification-list-leave-active {
      transition: opacity 0.4s;
    }

    .notification-list-enter, .notification-list-leave-to /* .list-leave-active for <2.1.8 */
    {
      opacity: 0;
    }
  }

</style>



// WEBPACK FOOTER //
// src/App.vue